/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, BehaviorSubject} from 'rxjs';
import {AppConfig} from '../../app.config';
@Injectable()
export class FrontUserNoActiveService  {
  static InjectorInstance: HttpClient;
  static Config: AppConfig;

  users: any[];
  onUsersChanged: BehaviorSubject<any> = new BehaviorSubject({});
  countryId = '';
  citiesId = [];
  organizationonsId = [];
  rolesId = [];
  addSuccess = false;
  targetGroups = [];
  tags = [];



  constructor (private http: HttpClient , private api: AppConfig) {
    FrontUserNoActiveService.InjectorInstance = this.http;
    FrontUserNoActiveService.Config = this.api;
  }


  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve (route: ActivatedRouteSnapshot , state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise<void>((resolve , reject) => {

      Promise.all([
        this.countryId = '' ,
        this.citiesId = [] ,
        this.rolesId = [] ,
        this.organizationonsId = [] ,
        this.targetGroups = [],
        this.getUsers()
      ]).then(
        () => {
          resolve();
        } ,
        reject
      );
    });
  }

  getUsers () {
    return new Promise((resolve , reject) => {
      this.http.get(this.api.baseUrl + '/frontUser/frontUsersNA?countryId=' + this.countryId + '&citiesId=' + this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() + '&organizationsId=' + this.organizationonsId.toString() + '&targetGroupsId=' + this.targetGroups.toString() + '&tags=' + this.tags.toString() + '&verify=0',
        this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.users = response;
          this.onUsersChanged.next(this.users);
          resolve(response);
        } , reject);
    });
  }

  getUsersCount () {
      return this.http.get(this.api.baseUrl + '/frontUser/newFrontUsersCount?countryId=' + this.countryId + '&citiesId=' + this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() + '&organizationsId=' + this.organizationonsId.toString() + '&targetGroupsId=' + this.targetGroups.toString() + '&tags=' + this.tags.toString() + '&verify=0',
        this.api.jsonTokenHeaders);
  }

}
